export default "__VITE_ASSET__c7e291c5__"